import { render, staticRenderFns } from "./servicesPage.vue?vue&type=template&id=c662dae8&"
import script from "./servicesPage.vue?vue&type=script&lang=js&"
export * from "./servicesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports